import React, { useEffect, useState } from "react";
import axios from "axios";
import QRCode from "qrcode";
import "./TokenList.css";

function TokenList({ authToken, refreshTrigger }) {
  const [tokens, setTokens] = useState([]);
  const [filteredTokens, setFilteredTokens] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterRange, setFilterRange] = useState("all");

  useEffect(() => {
    const fetchTokens = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/tokens`,
          {
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );
        setTokens(response.data);
        setFilteredTokens(response.data);
      } catch (err) {
        alert("Failed to fetch tokens");
        localStorage.removeItem("token");
        window.location.reload();
      }
    };
    fetchTokens();
  }, [authToken, refreshTrigger]);

  useEffect(() => {
    const now = new Date();

    const filterByRange = (token) => {
      const createdAt = new Date(token.createdAt);
      switch (filterRange) {
        case "today":
          return createdAt.toDateString() === now.toDateString();
        case "yesterday":
          const yesterday = new Date(now);
          yesterday.setDate(now.getDate() - 1);
          return createdAt.toDateString() === yesterday.toDateString();
        case "7days":
          return now - createdAt <= 7 * 24 * 60 * 60 * 1000;
        case "30days":
          return now - createdAt <= 30 * 24 * 60 * 60 * 1000;
        default:
          return true;
      }
    };

    const filterBySearchQuery = (token) => {
      const query = searchQuery.toLowerCase();
      return (
        token.truckNumber.toLowerCase().includes(query) ||
        token.transactionId.toLowerCase().includes(query)
      );
    };

    const filtered = tokens.filter(
      (token) => filterByRange(token) && filterBySearchQuery(token)
    );

    setFilteredTokens(filtered);
  }, [tokens, filterRange, searchQuery]);

  const handlePrint = async (token) => {
    try {
      const qrData = token.transactionId;
      const qrImage = await QRCode.toDataURL(qrData);
      const vehicleNumber = token.truckNumber;
      const tokenTime = token.createdAt;

      const printWindow = window.open("", "PRINT", "height=400,width=360");
      printWindow.document.write(`
        <html>
          <head>
            <title>Print QR Code</title>
            <style>
              body {
                width: 78mm;
                margin: 0 auto;
                padding: 0;
                font-family: monospace;
                text-align: center;
                font-size: 13px;
              }
              h2, h3, p {
                margin: 4px 0;
              }
              img {
                display: block;
                margin: 8px auto;
                max-width: 40%;
              }
              @media print {
                body {
                  margin: 0;
                }
              }
            </style>
          </head>
          <body>
            <h2>Courtyard Pavilion Pvt Ltd</h2>
            <h3>ID: ${qrData}</h3>
            <p>Vehicle Number: <b>${vehicleNumber}</b></p>
            <img src="${qrImage}" alt="QR Code" />
            <p>Time: <b>${new Date(tokenTime).toLocaleString()}</b></p>
            <script>
              window.onload = function () {
                window.print();
                window.onafterprint = function () {
                  window.close();
                };
              };
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
    } catch (err) {
      alert("Failed to generate QR code for print.");
    }
  };

  return (
    <div className="token-list-container">
      <div className="token-count">Total Count: {filteredTokens.length}</div>
      <div className="filter-controls">
        <label>Search: </label>
        <input
          type="text"
          placeholder="Search by truck number or transaction ID"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="filter-controls">
        <label>Filter by Date Range: </label>
        <select
          value={filterRange}
          onChange={(e) => setFilterRange(e.target.value)}
        >
          <option value="all">All</option>
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="7days">Last 7 Days</option>
          <option value="30days">Last 30 Days</option>
        </select>
      </div>

      <table className="token-table">
        <thead>
          <tr>
            <th>Truck Number</th>
            <th>Transaction ID</th>
            <th>Date</th>
            <th>Authorized By</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredTokens.length > 0 ? (
            filteredTokens.map((token) => (
              <tr key={token._id}>
                <td>{token.truckNumber}</td>
                <td>{token.transactionId}</td>
                <td>{new Date(token.createdAt).toLocaleString()}</td>
                <td>{token.createdBy}</td>
                <td>
                  <button onClick={() => handlePrint(token)}>Print</button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5">No tokens found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default TokenList;
